module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTBIOFYwSDBWMTBaTTAgMThIOFYxMkgwVjE4Wk0xMCAxOEgxOFY4SDEwVjE4Wk0xMCAwVjZIMThWMEgxMFoiIGZpbGw9IiNCNDFCM0UiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_menu_dashboard.svg
// module id = RFp1
// module chunks = 1